import { Pipe, PipeTransform } from '@angular/core'

import { Marked } from 'marked'
import { mangle } from 'marked-mangle'

// this token makes sure that markdown tables render properly.
const templateLiteralMultilineToken = `
`

function sanitizeString(value: string): string {
  const normalizedNewlineValue = value.replace(/\\r|\\n|\r|\n/g, '<br/>')
  const templateLiteralValue = normalizedNewlineValue.replace(
    /(?:<br\/>)/g,
    templateLiteralMultilineToken
  )

  return templateLiteralValue
}

@Pipe({
  name: 'flxAiMarkdown',
})
export class FlxAiMarkdownPipe implements PipeTransform {
  async transform(value: string): Promise<string> {
    if (value === null || value === undefined) {
      return value
    }

    const aiMarked = new Marked(mangle())

    const renderer = new aiMarked.Renderer()
    // make anchors open in new tab
    renderer.link = (...args) => {
      const link = aiMarked.Renderer.prototype.link.apply(this, args)
      return link.replace('<a', "<a target='_blank'")
    }

    // passed vale needs to be a string
    return aiMarked.parse(`${sanitizeString(value)}`, { renderer })
  }
}
